import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {FilterControls} from "../interface/filter-controls";
import {FilterControlOption} from "../interface/filter-control-option";
import {FilterService} from "../service/filter.service";
import {FilterCsvMetadataService} from "../service/filter-csv-metadata.service";
import {FilterOption} from "../interface/filter-option";

@Component({
	selector: 'fb-filter-active-controls',
	templateUrl: './filter-active-controls.component.html',
	styleUrls: ['./filter-active-controls.component.scss']
})
export class FilterActiveControlsComponent implements OnChanges {

	@Output()
	public onControlsChange: EventEmitter<null> = new EventEmitter<null>();

	@Input()
	public showClearFilterButton: boolean = false;

	@Input()
	public selectedFilters: FilterControlOption[] = [];

	@Input()
	public controls: FilterControls = {} as FilterControls;

	public showClearFilterButtonForCategory: boolean = true;

	constructor(
		private _filter: FilterService,
	) {
	}

	ngOnChanges(changes: SimpleChanges) {
		// this.showClearFilterButtonForCategory = this.showClearFilterButtonForCategoryFn();
		this.selectedFilters.forEach(filter => {
			if(filter.type === 'csv' && filter.option) {
				if(filter.name === 'Material') {
					filter.option.displayName = this.getMaterialValue(filter.option);
				}
				else if(filter.name === 'Pattern') {
					filter.option.displayName = this.getPatternValue(filter.option);
				}
				else if(filter.name === 'Color') {
					filter.option.displayName = this.getColourValue(filter.option);
				}
			}
		})
	}

	public getMaterialValue(option: FilterOption): string | undefined {
		return FilterCsvMetadataService.materialList.find(m => m.id === +option.value)?.name;
	}

	public getPatternValue(option: FilterOption): string | undefined {
		return FilterCsvMetadataService.patternList.find(m => m.id === +option.value)?.name;
	}

	public getColourValue(option: FilterOption): string | undefined {
		return FilterCsvMetadataService.colorList.find(m => m.id === +option.value)?.name;
	}

	public onFilterControlChange(): void {
		this.onControlsChange.next(null);
	}

	public clearAllFilterOption(): void {
		this._filter.clearAllFilter(this.controls);
		this.onFilterControlChange();
	}

	public clearFilter(filter: FilterControlOption): void {
		if (filter.option) {
			filter.option.active = false;
			if(filter.mainOption) {
				filter.mainOption.active = false;
			}
		}
		else {
			if(!filter.range)
				return;
			filter.range.active = false;
			filter.range.value1 = filter.range.defaultMin;
			filter.range.value2 = filter.range.defaultMax;
		}
		this.onFilterControlChange();
	}

	public showFilter(filter: FilterControlOption): boolean {
		if(['default', 'sub'].includes(filter.type)) {
			if(filter.option) {
				return !['accessories', 'home', 'apparel', 'swatchkits'].includes(filter.option.value.toLowerCase())
			}
		}

		return true;
	}

	public showClearFilterButtonForCategoryFn(): boolean {
		if(this.selectedFilters && this.selectedFilters.length === 1)
		{
			return this.showFilter(this.selectedFilters[0]);
		}
		return true;
	}
}
